import {
  Validators,
  AbstractControl,
  ValidatorFn,
  ValidationErrors,
} from '@angular/forms';

import { isPresent } from '../utils/is-present';

export const personName: ValidatorFn = (
  control: AbstractControl
): ValidationErrors => {
  if (isPresent(Validators.required(control))) {
    return null;
  }

  const v: string = control.value;
  return /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g.test(v)
    ? null
    : { personName: true };
};
